export default __webpack_public_path__ + "static/media/bihorel2.648c8593.jpg";